import React, { useState, useContext, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ConfigContext } from "../Context/ConfigContext";
import { useTranslation } from "react-i18next";
import slugify from "slugify";
import MobileSearchBar from "../Components/SearchBar/MobileSearchBar";
import MobileMyGarage from "./MobileMyGarage";

const MobileHeader = () => {

  const {
    FavItemsQty,
    marqueeRows
  } = useContext(ConfigContext);


  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showTrainingModal, setShowTrainingModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const openDrawer = () => setDrawerOpen(true);
  const closeDrawer = () => setDrawerOpen(false);

  const handleBasketClick = () => {
    navigate("/basket");
  };

  useEffect(() => {
    closeDrawer();
  }, [location]);

  const hasDiscount = marqueeRows?.some(
    (sup) => sup?.SUP_BRAND && Number(sup?.business_brand_discount || 0) > 0
  );


  return (
    <>
      {/* HEADER */}

      {
        marqueeRows?.length > 0 && hasDiscount &&
        <div className="header-top darkColor" style={{ color: "#FFF", paddingTop: '10px', height: '45px' }}>

          <div className="container" dir="ltr">
            <div className="header-left w-100">

              <div className="marquee-wrapper">
                <div className="marquee-content">

                  {[...Array(2)].map((_, i) => (
                    <div className="marquee-track" key={i}>

                      <span className="marquee-text">
                        Special Discounts on Spare Parts from
                      </span>

                      {marqueeRows.map((sup, index) => {
                        if (!sup?.SUP_BRAND || Number(sup.business_brand_discount) <= 0) return null;

                        return (
                          <span key={`${i}-${index}`} className="marquee-item">
                            <NavLink to={`/Spare-Parts/PartsByBrand/${sup.SUP_ID}-${sup.SUP_BRAND}`}>
                              {sup.SUP_BRAND} ({sup.business_brand_discount}%) OFF
                            </NavLink>
                          </span>
                        );
                      })}

                    </div>
                  ))}

                </div>
              </div>

            </div>

            {/* ✅ Internal CSS */}
            <style>
              {`
          .marquee-wrapper {
            overflow: hidden;
          }

          .marquee-content {
            display: flex;
            width: max-content;
            animation: scrollLeft 18s linear infinite;
          }

          .marquee-content:hover {
            animation-play-state: paused;
          }

          .marquee-track {
            display: flex;
            align-items: center;
            white-space: nowrap;
          }

          .marquee-text {
            color: #fff;
            font-weight: 600;
            margin-right: 15px;
            font-size: 14px;
          }

          .marquee-item {
            margin: 0 15px;
          }

          @keyframes scrollLeft {
            0% { transform: translateX(0%); }
            100% { transform: translateX(-50%); }
          }
        `}
            </style>
          </div>

        </div>
      }

      <div
        className="d-flex justify-content-between align-items-center"
        style={{ background: "#132530", padding: "10px 15px" }}
      >
        <div onClick={openDrawer} style={{ cursor: "pointer" }}>
          <i className="fas fa-bars" style={{ color: "#bfcbd2", fontSize: "20px" }} />
        </div>

        <div>
          <img
            src={`/assets/images/Logo/car7_transparent_powered_by.png`}
            style={{ height: "50px", cursor: "pointer" }}
            onClick={() => (window.location = "/")}
            alt="Logo"
            className="img-fluid"
          />
        </div>

        <div onClick={handleBasketClick} style={{ cursor: "pointer" }}>
          <i className="fas fa-shopping-cart" style={{ color: "#bfcbd2", fontSize: "20px" }} />
        </div>
      </div>

      <div className="pb-5">
        <MobileSearchBar />
      </div>

      {showTrainingModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.8)",
            zIndex: 20000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            animation: "fadeIn 0.3s ease-out",
          }}
          onClick={() => setShowTrainingModal(false)}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "8px",
              maxWidth: "90%",
              width: "400px",
              animation: "scaleIn 0.3s ease-out",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Training Content</h3>
            <p>Your training content goes here</p>
            <button
              onClick={() => setShowTrainingModal(false)}
              style={{
                padding: "10px 20px",
                background: "#184560",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* SIDEBAR OVERLAY */}
      <div
        onClick={closeDrawer}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.4)",
          zIndex: 9998,
          opacity: drawerOpen ? 1 : 0,
          visibility: drawerOpen ? "visible" : "hidden",
          transition: "opacity 0.3s ease-out, visibility 0.3s ease-out",
        }}
      />

      {/* SIDEBAR */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "300px",
          height: "100vh",
          background: "#f9fafb",
          zIndex: 9999,
          overflowY: "auto",
          transform: drawerOpen ? "translateX(0)" : "translateX(-100%)",
          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          boxShadow: drawerOpen ? "2px 0 8px rgba(0,0,0,0.15)" : "none",
        }}
      >
        <span
          onClick={closeDrawer}
          style={{
            position: "absolute",
            right: "15px",
            top: "15px",
            fontSize: "20px",
            cursor: "pointer",
            color: "#184560",
            zIndex: 10,
          }}
        >
          <i className="fa fa-times" />
        </span>

        <SidebarMenu closeDrawer={closeDrawer} FavItemsQty={FavItemsQty} setShowTrainingModal={setShowTrainingModal} />
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        
        @keyframes scaleIn {
          from {
            transform: scale(0.9);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }
      `}</style>
    </>
  );
};

/* ---------------- SIDEBAR MENU ---------------- */

const SidebarMenu = ({ closeDrawer, FavItemsQty, setShowTrainingModal }) => {
  const { categories, treeCategories, gdcURL } = useContext(ConfigContext);
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const [navHistory, setNavHistory] = useState([null]);
  const [myGarageStatus, setMyGarageStatus] = useState(false);
  const [carPartsDropdownOpen, setCarPartsDropdownOpen] = useState(false);
  const [childCategoriesOpen, setChildCategoriesOpen] = useState(false);
  const [selectedParentCategory, setSelectedParentCategory] = useState(null);
  const [childNavHistory, setChildNavHistory] = useState([null]);

  const hasChildren = (nodeId) => {
    return categories.some((item) => item.STR_ID_PARENT === nodeId);
  };

  categories.forEach((item) => {
    item.STR_CHILDREN = hasChildren(item.STR_ID);
  });

  useEffect(() => {
    setMyGarageStatus(false);
    setCarPartsDropdownOpen(false);
    setChildCategoriesOpen(false);
    setNavHistory([null]);
    setChildNavHistory([null]);
    setSelectedParentCategory(null);
  }, [location]);

  const handleCarPartsClick = () => {
    setCarPartsDropdownOpen(!carPartsDropdownOpen);
    setNavHistory([null]);
    setChildCategoriesOpen(false);
  };

  const handleMyGarageClick = () => {
    setMyGarageStatus(true);
    setCarPartsDropdownOpen(false);
    setChildCategoriesOpen(false);
  };

  const handleCategoryClick = (item) => {
    if (item.STR_CHILDREN) {
      setSelectedParentCategory(item);
      setChildCategoriesOpen(true);
      setChildNavHistory([null]);
    } else {
      const url = `/Spare-Parts/${slugify(item.STR_NODE_NAME)}-${item.STR_ID}`;
      window.location.href = url;
      closeDrawer();
    }
  };

  const handleChildCategoryClick = (item) => {
    if (item.STR_CHILDREN) {
      setChildNavHistory([item.STR_ID, ...childNavHistory]);
    } else {
      const url = `/Spare-Parts/${slugify(item.STR_NODE_NAME)}-${item.STR_ID}`;
      window.location.href = url;
      closeDrawer();
    }
  };

  const handleChildBackClick = () => {
    if (childNavHistory.length > 1) {
      setChildNavHistory(childNavHistory.slice(1));
    }
  };

  const closeChildCategories = () => {
    setChildCategoriesOpen(false);
    setSelectedParentCategory(null);
    setChildNavHistory([null]);
  };

  const closeMyGarage = () => {
    setMyGarageStatus(false);
  };

  const handleNavigation = (to) => {
    closeDrawer();
    if (to) {
      navigate(to);
    }
  };

  const handleBasketClick = () => {
    closeDrawer();
    navigate("/basket");
  };

  // Menu item component for consistent styling
  const MenuItem = ({ onClick, to, icon, children, hasChevron = false, isActive = false }) => {
    const content = (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "15px",
          cursor: "pointer",
          transition: "background-color 0.2s ease",
          backgroundColor: isActive ? "#f8f9fa" : "transparent",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#f8f9fa";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = isActive ? "#f8f9fa" : "transparent";
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div style={{ width: "20px", display: "flex", justifyContent: "center" }}>
            {icon}
          </div>
          <span style={{ color: "#000", fontSize: "15px", fontWeight: "500" }}>
            {children}
          </span>
        </div>
        {hasChevron && (
          <i
            className="fas fa-chevron-right"
            style={{
              color: "#184560",
              fontSize: "12px",
              transition: "transform 0.2s ease",
              transform: isActive ? "rotate(90deg)" : "rotate(0deg)"
            }}
          />
        )}
      </div>
    );

    if (to) {
      return (
        <NavLink
          to={to}
          onClick={() => handleNavigation(to)}
          style={{ textDecoration: "none", display: "block" }}
        >
          {content}
        </NavLink>
      );
    }

    return <div onClick={onClick}>{content}</div>;
  };

  return (
    <div style={{ marginTop: "40px" }}>
      {/* My Garage Panel */}
      {myGarageStatus && (
        <>
          <div
            onClick={closeMyGarage}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.4)",
              zIndex: 10000,
              animation: "fadeIn 0.3s ease-out",
            }}
          />

          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "300px",
              height: "100vh",
              background: "#fff",
              zIndex: 10001,
              overflowY: "auto",
              boxShadow: "2px 0 8px rgba(0,0,0,0.15)",
              transform: "translateX(0)",
              transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              animation: "slideIn 0.3s ease-out",
            }}
          >
            <div
              style={{
                padding: "15px",
                borderBottom: "1px solid #e5e7eb",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#f8f9fa",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <i
                  onClick={closeMyGarage}
                  className="fas fa-arrow-left"
                  style={{ cursor: "pointer", fontSize: "18px", color: "#184560", transition: "transform 0.2s ease" }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateX(-3px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateX(0)"}
                />
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <i className="fas fa-car" style={{ fontSize: "18px", color: "#184560" }} />
                  <h3 style={{ fontSize: "17px", margin: 0, color: "#184560" }}>
                    {t("my_cars")}
                  </h3>
                </div>
              </div>
              <i
                onClick={closeMyGarage}
                className="fa fa-times"
                style={{ cursor: "pointer", fontSize: "18px", color: "#184560", transition: "transform 0.2s ease" }}
                onMouseEnter={(e) => e.currentTarget.style.transform = "rotate(90deg)"}
                onMouseLeave={(e) => e.currentTarget.style.transform = "rotate(0deg)"}
              />
            </div>

            <div style={{ padding: "15px" }}>
              <MobileMyGarage closeDrawer={closeDrawer} />
            </div>
          </div>
        </>
      )}

      {/* Child Categories Panel */}
      {childCategoriesOpen && selectedParentCategory && (
        <>
          <div
            onClick={closeChildCategories}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.4)",
              zIndex: 10002,
              animation: "fadeIn 0.3s ease-out",
            }}
          />

          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "300px",
              height: "100vh",
              background: "#fff",
              zIndex: 10003,
              overflowY: "auto",
              boxShadow: "2px 0 8px rgba(0,0,0,0.15)",
              transform: "translateX(0)",
              transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              animation: "slideIn 0.3s ease-out",
            }}
          >
            <div
              style={{
                padding: "15px",
                borderBottom: "1px solid #e5e7eb",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#f8f9fa",
                position: "sticky",
                top: 0,
                zIndex: 10,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "12px", flex: 1 }}>
                <i
                  onClick={closeChildCategories}
                  className="fas fa-arrow-left"
                  style={{ cursor: "pointer", fontSize: "18px", color: "#184560", transition: "transform 0.2s ease" }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateX(-3px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateX(0)"}
                />
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <img
                    src={`${gdcURL}/category-images/600x600/${selectedParentCategory.STR_ID}`}
                    alt={selectedParentCategory.STR_NODE_NAME}
                    style={{
                      width: "30px",
                      height: "30px",
                      objectFit: "cover",
                      borderRadius: "4px",
                    }}
                    onError={(e) => {
                      e.target.src = `/assets/images/placeholder.jpg`;
                    }}
                  />
                  <h3 style={{ fontSize: "17px", margin: 0, color: "#184560" }}>
                    {selectedParentCategory.STR_NODE_NAME}
                  </h3>
                </div>
              </div>
              <i
                onClick={closeChildCategories}
                className="fa fa-times"
                style={{ cursor: "pointer", fontSize: "18px", color: "#184560", transition: "transform 0.2s ease" }}
                onMouseEnter={(e) => e.currentTarget.style.transform = "rotate(90deg)"}
                onMouseLeave={(e) => e.currentTarget.style.transform = "rotate(0deg)"}
              />
            </div>

            {childNavHistory.length > 1 && (
              <div
                onClick={handleChildBackClick}
                style={{
                  padding: "12px 15px",
                  cursor: "pointer",
                  borderBottom: "1px solid #e5e7eb",
                  color: "#184560",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  backgroundColor: "#f8f9fa",
                  transition: "background-color 0.2s ease",
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#e9ecef"}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
              >
                <i className="fas fa-chevron-left" style={{ fontSize: "12px" }}></i>
                <span>Back</span>
              </div>
            )}

            <div style={{ padding: "0" }}>
              {categories.map((item, index) => {
                const parentId = childNavHistory[0] === null
                  ? selectedParentCategory.STR_ID
                  : childNavHistory[0];

                if (item.STR_ID_PARENT === parentId) {
                  return (
                    <div
                      key={index}
                      onClick={() => handleChildCategoryClick(item)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "12px 15px",
                        borderBottom: "1px solid #e5e7eb",
                        cursor: "pointer",
                        transition: "background-color 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f8f9fa";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <img
                          src={`${gdcURL}/category-images/600x600/${item.STR_ID}`}
                          alt={item.STR_NODE_NAME}
                          style={{
                            width: "35px",
                            height: "35px",
                            objectFit: "cover",
                            borderRadius: "4px",
                          }}
                          onError={(e) => {
                            e.target.src = `/assets/images/placeholder.jpg`;
                          }}
                        />
                        <span style={{ color: "#000", fontSize: "14px", fontWeight: "500" }}>
                          {item.STR_NODE_NAME}
                        </span>
                      </div>

                      {item.STR_CHILDREN && (
                        <i className="fas fa-chevron-right" style={{ color: "#ccc", fontSize: "12px" }}></i>
                      )}
                    </div>
                  );
                }
                return null;
              })}
            </div>
          </div>
        </>
      )}

      {/* Main Menu */}
      {!myGarageStatus && !childCategoriesOpen && (
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {/* Account */}
          <li style={{ borderBottom: "1px solid #e5e7eb" }}>
            <MenuItem
              to={localStorage.getItem("business_id") ? "/MyAccount" : "/Signup"}
              icon={<i className="fas fa-user" style={{ fontSize: "18px", color: "#184560", width: "18px" }}></i>}
            >
              {localStorage.getItem("business_id") ? t("my_account") : t("signin")}
            </MenuItem>
          </li>

          {/* My Garage */}
          <li style={{ borderBottom: "1px solid #e5e7eb" }}>
            <MenuItem
              onClick={handleMyGarageClick}
              icon={<i className="fas fa-car" style={{ fontSize: "18px", color: "#184560", width: "18px" }}></i>}
              hasChevron={true}
            >
              {t("my_cars")}
            </MenuItem>
          </li>

          {/* Basket */}
          <li style={{ borderBottom: "1px solid #e5e7eb" }}>
            <MenuItem
              onClick={handleBasketClick}
              icon={<i className="fas fa-shopping-cart" style={{ fontSize: "18px", color: "#184560", width: "18px" }}></i>}
            >
              Basket
            </MenuItem>
          </li>

          {/* Car Parts */}
          <li style={{ borderBottom: "1px solid #e5e7eb" }}>
            <MenuItem
              onClick={handleCarPartsClick}
              icon={
                <svg className="header-nav__icon base-svg" role="img" style={{ width: "18px", height: "18px", fill: "#184560" }}>
                  <use href="/assets/images/icon-sprite-bw.svg#sprite-garage-car-icon-bw"></use>
                </svg>
              }
              hasChevron={true}
              isActive={carPartsDropdownOpen}
            >
              Car Parts
            </MenuItem>

            {carPartsDropdownOpen && (
              <div style={{
                backgroundColor: "#fff",
                borderTop: "1px solid #e5e7eb",
                animation: "dropdownSlide 0.2s ease-out",
                maxHeight: "400px",
                overflowY: "auto",
              }}>
                {categories.map((item, index) => {
                  if (item.STR_ID_PARENT === null) {
                    return (
                      <div
                        key={index}
                        onClick={() => handleCategoryClick(item)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "12px 15px 12px 45px",
                          borderBottom: "1px solid #e5e7eb",
                          cursor: "pointer",
                          transition: "background-color 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f8f9fa";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "transparent";
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                          <img
                            src={`${gdcURL}/category-images/600x600/${item.STR_ID}`}
                            alt={item.STR_NODE_NAME}
                            style={{
                              width: "30px",
                              height: "30px",
                              objectFit: "cover",
                              borderRadius: "4px",
                            }}
                            onError={(e) => {
                              e.target.src = `/assets/images/placeholder.jpg`;
                            }}
                          />
                          <span style={{ color: "#000", fontSize: "14px", fontWeight: "500" }}>
                            {item.STR_NODE_NAME}
                          </span>
                        </div>

                        {item.STR_CHILDREN && (
                          <i className="fas fa-chevron-right" style={{ color: "#ccc", fontSize: "12px" }}></i>
                        )}
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
            )}
          </li>

          {/* Oil & Lubes - CORRECTED VERSION */}
          <li style={{ borderBottom: "1px solid #e5e7eb" }}>
            <MenuItem
              to="/Spare-Parts/Oil"
              icon={
                <svg
                  className="header-nav__icon base-svg"
                  role="img"
                  style={{ width: "25px", height: "25px", marginTop: "-2px", fill: "#184560", marginRight: "7px" }}
                >
                  <use href="/assets/images/icon-sprite-bw.svg#sprite-oil-icon-bw" />
                </svg>
              }
            >
              Oil & Lubes
            </MenuItem>
          </li>

          {/* AC Compressor */}
          <li style={{ borderBottom: "1px solid #e5e7eb" }}>
            <MenuItem
              to="/Spare-Parts/Spare-Parts-nocar/100354/CompressorParts"
              icon={
                <svg style={{ width: "18px", height: "18px", fill: "#184560" }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                  <path d="M8 7.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1" />
                  <path d="M8 16a.5.5 0 0 1-.5-.5v-1.293l-.646.647a.5.5 0 0 1-.707-.708L7.5 12.793v-1.51l-2.053-1.232-1.348.778-.495 1.85a.5.5 0 1 1-.966-.26l.237-.882-1.12.646a.5.5 0 0 1-.5-.866l1.12-.646-.883-.237a.5.5 0 1 1 .258-.966l1.85.495L5 9.155v-2.31l-1.4-.808-1.85.495a.5.5 0 1 1-.259-.966l.884-.237-1.12-.646a.5.5 0 0 1 .5-.866l1.12.646-.237-.883a.5.5 0 1 1 .966-.258l.495 1.849 1.348.778L7.5 4.717v-1.51L6.147 1.854a.5.5 0 1 1 .707-.708l.646.647V.5a.5.5 0 0 1 1 0v1.293l.647-.647a.5.5 0 1 1 .707.708L8.5 3.207v1.51l2.053 1.232 1.348-.778.495-1.85a.5.5 0 1 1 .966.26l-.236.882 1.12-.646a.5.5 0 0 1 .5.866l-1.12.646.883.237a.5.5 0 1 1-.26.966l-1.848-.495-1.4.808v2.31l1.4.808 1.849-.495a.5.5 0 1 1 .259.966l-.883.237 1.12.646a.5.5 0 0 1-.5.866l-1.12-.646.236.883a.5.5 0 1 1-.966.258l-.495-1.849-1.348-.778L8.5 11.283v1.51l1.354 1.353a.5.5 0 0 1-.707.708l-.647-.647V15.5a.5.5 0 0 1-.5.5m2-6.783V6.783l-2-1.2-2 1.2v2.434l2 1.2z" />
                </svg>
              }
            >
              AC Compressor
            </MenuItem>
          </li>

          {/* Condenser */}
          <li style={{ borderBottom: "1px solid #e5e7eb" }}>
            <MenuItem
              to="/Spare-Parts/Spare-Parts-nocar/100355/Condenser"
              icon={
                <svg style={{ width: "18px", height: "18px", fill: "#184560" }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                  <path d="M7.765 1.559a.5.5 0 0 1 .47 0l7.5 4a.5.5 0 0 1 0 .882l-7.5 4a.5.5 0 0 1-.47 0l-7.5-4a.5.5 0 0 1 0-.882z" />
                  <path d="m2.125 8.567-1.86.992a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882l-1.86-.992-5.17 2.756a1.5 1.5 0 0 1-1.41 0z" />
                </svg>
              }
            >
              Condenser
            </MenuItem>
          </li>

          {/* Track My Orders */}
          <li style={{ borderBottom: "1px solid #e5e7eb" }}>
            <MenuItem
              to="/MyAccount/Orders"
              icon={<i className="fas fa-clipboard-list" style={{ fontSize: "18px", color: "#184560", width: "18px" }}></i>}
            >
              Track My Orders
            </MenuItem>
          </li>

          {/* Favourites */}
          <li style={{ borderBottom: "1px solid #e5e7eb" }}>
            <MenuItem
              to="/MyAccount/Favourites"
              icon={
                <div style={{ position: "relative", display: "inline-block" }}>
                  <i className="fas fa-heart" style={{ fontSize: "18px", color: "#184560", width: "18px" }}></i>
                  {FavItemsQty > 0 && (
                    <span
                      style={{
                        position: "absolute",
                        top: "-8px",
                        left: "-5px",
                        background: "red",
                        color: "white",
                        borderRadius: "50%",
                        padding: "2px 5px",
                        fontSize: "10px",
                        fontWeight: "bold",
                        lineHeight: 1,
                        minWidth: "16px",
                        textAlign: "center"
                      }}
                    >
                      {FavItemsQty}
                    </span>
                  )}
                </div>
              }
            >
              Favourites
            </MenuItem>
          </li>

          {/* Promotions & Deals */}
          <li style={{ borderBottom: "1px solid #e5e7eb" }}>
            <MenuItem
              to="/Spare-Parts/SpecialOffers"
              icon={<i className="fas fa-star" style={{ fontSize: "18px", color: "#184560", width: "18px" }}></i>}
            >
              Promotions & Deals
            </MenuItem>
          </li>

          {/* Redeem Points */}
          <li style={{ borderBottom: "1px solid #e5e7eb" }}>
            <MenuItem
              to="/MyAccount/RedeemPoints"
              icon={<i className="fas fa-coins" style={{ fontSize: "18px", color: "#184560", width: "18px" }}></i>}
            >
              <span style={{ fontSize: "18px", color: "#184560" }}>Redeem Points</span>
            </MenuItem>
          </li>

          {/* Train Yourself */}
          <li style={{ borderBottom: "1px solid #e5e7eb" }}>
            <MenuItem
              onClick={() => {
                setShowTrainingModal(true);
                closeDrawer();
              }}
              icon={<i className="fas fa-play" style={{ fontSize: "18px", color: "#184560", width: "18px" }}></i>}
            >
              Train Your Self
            </MenuItem>
          </li>
        </ul>
      )}

      <style jsx>{`
        @keyframes slideIn {
          from {
            transform: translateX(-100%);
          }
          to {
            transform: translateX(0);
          }
        }
        
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        
        @keyframes dropdownSlide {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

// CSS animations - Add to head only once
if (typeof document !== 'undefined' && !document.getElementById('mobile-header-styles')) {
  const styleSheet = document.createElement("style");
  styleSheet.id = 'mobile-header-styles';
  styleSheet.textContent = `
    @keyframes slideIn {
      from {
        transform: translateX(-100%);
      }
      to {
        transform: translateX(0);
      }
    }
    
    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    
    @keyframes scaleIn {
      from {
        transform: scale(0.9);
        opacity: 0;
      }
      to {
        transform: scale(1);
        opacity: 1;
      }
    }
    
    @keyframes dropdownSlide {
      from {
        opacity: 0;
        transform: translateY(-10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `;
  document.head.appendChild(styleSheet);
}

export default MobileHeader;